// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3aWyg","clinicsSelect":"TableHeading_clinicsSelect__Ci6N4"};